import { useMutation, useQueryClient } from 'react-query';
import { enviarOktonBank } from '../oktonbank';

// Mesmos campos da tela de Contas Bancárias do IFLEX. A Moeda é obrigatória:
// sem ela o Monitor Bancário não resolve a Conta a partir do lançamento, e a
// conciliação não encontra título nenhum.
export interface DadosContaBancaria {
  descricao: string;
  numero: string;
  digito: string;
  tipo: string;
  moeda: string;
  saldoinicial: string;
  banco?: string;
  agencia?: string;
  agencianumero?: string;
  agenciadigito?: string;
  agenciaposto?: string;
}

function invalidarContas(queryClient: ReturnType<typeof useQueryClient>) {
  queryClient.invalidateQueries('contas-bancarias');
  queryClient.invalidateQueries('monitor-bancario-resumo');
  queryClient.invalidateQueries('dashboard');
  // A lista de Moedas livres muda a cada vínculo criado ou desfeito.
  queryClient.invalidateQueries('oktonbank-moedas');
}

export function useCreateContaBancaria() {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: DadosContaBancaria) =>
      enviarOktonBank('OBContas', 'gravar', { ...payload }),
    { onSuccess: () => invalidarContas(queryClient) },
  );
}

export function useUpdateContaBancaria() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, ...payload }: DadosContaBancaria & { id: string }) =>
      enviarOktonBank('OBContas', 'gravar', { id, ...payload }),
    { onSuccess: () => invalidarContas(queryClient) },
  );
}

export function useDeleteContaBancaria() {
  const queryClient = useQueryClient();

  return useMutation(
    (id: string) => enviarOktonBank('OBContas', 'excluir', { conta: id }),
    { onSuccess: () => invalidarContas(queryClient) },
  );
}
